import '.c8{position:relative;}.ssr-plugin'
import '.a3{display:inline-flex;}.ssr-plugin'
import '.k{justify-content:center;}.ssr-plugin'
import '.v{align-items:center;}.ssr-plugin'
import '.aw{cursor:pointer;}.ssr-plugin'
import '.b9{position:absolute;}.ssr-plugin'
import '.dj{top:-6px;}.ssr-plugin'
import '.dk{right:-6px;}.ssr-plugin'
import '.dl{min-width:1.125rem;}.ssr-plugin'
import '.dm{height:1.125rem;}.ssr-plugin'
import '.dn{padding:0 0.125rem;}.ssr-plugin'
import '.do{border-radius:100%;}.ssr-plugin'
import '.dp{border:2px solid var(--palette-white);}.ssr-plugin'
import '.dq{background:var(--brand-primary);}.ssr-plugin'
import '.a9{color:var(--palette-white);}.ssr-plugin'
import '.dr{font-size:0.625rem;}.ssr-plugin'
import '.ds{font-weight:700;}.ssr-plugin'
import '.dt{line-height:0.8725rem;}.ssr-plugin'
import '.w{text-align:center;}.ssr-plugin'
import '.du{pointer-events:none;}.ssr-plugin'
import { styled, type Style } from 'inlines'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { type IconDefinition } from '@fortawesome/pro-solid-svg-icons'

export type IconButtonProps = {
  variant?: Variant
  size?: Size
  shape?: Shape
  icon: IconDefinition
  disabled?: boolean
  style?: Style
  onClick: () => void
  notification?: number
}

type Size = 'medium' | 'small'
type Variant = 'primary' | 'secondary' | 'transparent'
type Shape = 'square' | 'circle'

const sizeStyle: Record<Size, Style> = {
  medium: {
    width: '3rem',
    height: '3rem',
    padding: '0.625rem',
    aspectRatio: '1/1',
    fontSize: '1.125rem',
  },
  small: {
    width: '2rem',
    height: '2rem',
    padding: '0.25rem',
    aspectRatio: '1/1',
    fontSize: '0.875rem',
  },
}

const shapeStyle: Record<Shape, Style> = {
  square: { borderRadius: '0.625rem' },
  circle: { borderRadius: '50%' },
}

const variantStyle: Record<Variant, Style> = {
  primary: {
    color: 'var(--palette-white)',
    background: 'var(--brand-primary)',
    border: '2px solid var(--brand-primary)',
    '&:hover': {
      background: 'var(--palette-red-600)',
      border: '2px solid var(--palette-red-600)',
    },
    '&:active': {
      background: 'var(--palette-red-600)',
      border: '2px solid var(--palette-red-600)',
    },
    '&:disabled': {
      background: 'var(--palette-red-200)',
      border: '2px solid var(--palette-red-200)',
    },
  },
  secondary: {
    color: 'var(--brand-secondary)',
    background: 'var(--gray-100)',
    border: '2px solid var(--gray-100)',
    '&:hover': {
      background: 'var(--palette-blue-50)',
      border: '2px solid var(--palette-blue-50)',
    },
    '&:active': {
      background: 'var(--palette-blue-50)',
      border: '2px solid var(--palette-blue-50)',
    },
    '&:disabled': {
      color: 'var(--palette-blue-100)',
    },
  },
  transparent: {
    color: 'var(--brand-secondary)',
    background: 'transparent',
    border: '2px solid var(--brand-secondary)',
    '&:active': {
      background: 'var(--palette-blue-50)',
      border: '2px solid var(--palette-blue-50)',
    },
    '&:disabled': {
      color: 'var(--palette-blue-100)',
    },
  },
}

export const IconButton = ({
  variant = 'primary',
  size = 'medium',
  shape = 'square',
  icon,
  disabled = false,
  style,
  onClick,
  notification,
}: IconButtonProps) => {
  return (
    <div className="c8 a3">
      <styled.button className="a3 k v aw"
        disabled={disabled}
        onClick={onClick}
        style={{
          '&:hover:disabled': {
            cursor: 'not-allowed',
          },
          ...variantStyle[variant],
          ...sizeStyle[size],
          ...shapeStyle[shape],
          ...style,
        }}
      >
        <FontAwesomeIcon
          icon={icon}
          style={{ width: '100%', height: '100%' }}
        />
      </styled.button>
      {notification > 0 && (
        <span className="b9 dj dk dl dm dn do dp dq a9 dr ds dt w du"
        >
          {notification}
        </span>
      )}
    </div>
  )
}
